import { Left } from "./left.js";
import { Right } from "./right.js";
/**
 * @public
 */
export var Either;
(function (Either) {
    function isEither(value) {
        return isLeft(value) || isRight(value);
    }
    Either.isEither = isEither;
    function isLeft(value) {
        return Left.isLeft(value);
    }
    Either.isLeft = isLeft;
    function isRight(value) {
        return Right.isRight(value);
    }
    Either.isRight = isRight;
    function left(value) {
        return Left.of(value);
    }
    Either.left = left;
    function right(value) {
        return Right.of(value);
    }
    Either.right = right;
})(Either || (Either = {}));
//# sourceMappingURL=either.js.map